import { createSelectorHook, createDispatchHook } from 'react-redux';
import { StoreContext } from './storeContext';
import { WidthsStoreContext } from './widthsStoreContext';
import { SelectionStoreContext } from './selectionStoreContext';
export const useWidthsSelector = createSelectorHook(WidthsStoreContext);
export const useWidthsDispatch = createDispatchHook(WidthsStoreContext);
export const useSelectionSelector = createSelectorHook(SelectionStoreContext);
export const useSelectionDispatch = createDispatchHook(SelectionStoreContext);
export const useTableSelector = createSelectorHook(StoreContext);
export const useTableDispatch = createDispatchHook(StoreContext);